import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Props } from './SisuFunnelBanner';
import { restrictLoggedOut } from '../redux/loggedout/actionCreators';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, 'restrictLoggedOut'>;
export type OwnProps = Omit<Props, keyof DispatchProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  any
> = state => ({});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  restrictLoggedOut,
};

export default connect(mapStateToProps, mapDispatchToProps);
